<template>
  <tr v-if="item">
    <td class="relative text-center">
      <v-tooltip
        bottom
        v-if="item.environment_support.includes('on-prem')"
      >
        <template v-slot:activator="{ on, attrs }">
          <div v-on="on">
            <v-btn
              text
              icon
            >
              <v-icon
                :color="theme.tabelEnteries"
                dark
                :class="'ml-2'"
                v-bind="attrs"
                style="margin-left: 0 !important"
              >
                {{ 'desktop_mac' }}
              </v-icon>
            </v-btn>
          </div>
        </template>
        <span>{{'On Premise'}}</span>
      </v-tooltip>
      <div v-else>
        <div v-if="cloudServices.length">
          <v-tooltip
            bottom
            v-if="cloudServices.length <= 1"
          >
            <template v-slot:activator="{ on, attrs }">
              <div v-on="on">
                <v-btn
                  text
                  icon
                >
                  <img class="azure-logo" v-bind="attrs" style="max-width: 30px; max-height: 25px;" :src="environmentLogo[cloudServices[0]]" />
                </v-btn>
              </div>
            </template>
            <span>{{cloudLabel(cloudServices[0])}}</span>
          </v-tooltip>
          <template v-else>
            <v-tooltip
              bottom
              v-if="cloudServices.length > 1"
            >
              <template v-slot:activator="{ on, attrs }">
                <div v-on="on" style="postion: relative">
                  <div
                    text
                    icon
                    v-for="cloud,index in majorCloudServices" :key="cloud"
                    class="cloud-logo"
                    :style="{left: calLeft(index, majorCloudServices.length) }"
                    :class="{blur: index !== majorCloudServices.length - 1}"
                  >
                    <img v-bind="attrs" style="max-width: 30px; max-height: 25px;" :src="environmentLogo[cloud]" />
                  </div>
                </div>
              </template>
              <div class="tooltip-contailer">
                <div>{{'Connected Cloud Apps'}}</div>
                <div class="logos-container">
                  <div
                    v-for="service in cloudServices"
                    :key="service"
                    class="logo"
                  >
                    <img class="azure-logo" style="max-width: 40px;" :src="environmentLogo[service]" />
                    <div>{{cloudLabel(service)}}</div>
                  </div>
                </div>
              </div>
            </v-tooltip>
          </template>
        </div>
        <v-btn
          text
          icon
          v-else
        >
          <v-icon
            :color="'grey'"
            dark
            :class="'ml-2'"
            style="margin-left: 0 !important"
          >
            {{ 'cloud' }}
          </v-icon>
        </v-btn>
      </div>
    </td>
    <td>
      {{item.name}}
    </td>
    <td>{{item.collector_version ||  '-'}}</td>
    <td>
      <template v-if="item.intervals">
        {{item.intervals}}s
        <v-btn icon @click.stop="$emit('openEditInterval', item)">
          <v-icon class="muted--white">edit</v-icon>
        </v-btn>
      </template>
      <template v-else>
        N/A
      </template>
    </td>
    <td>
      {{ item.public_ip }}
    </td>
    <td>
      <span class="status" :class="getStatusClass(item.status)">{{item.intervals ? item.status : 'Unknown'}}
      </span>
    </td>
    <td>
      <div class="d-flex justify-space-between">
        <v-menu max-width="340px" nudge-width="340px" offset-y left>
          <template v-slot:activator="{ on }">
            <v-btn
              text
              icon
              class="white-bg"
              dark
              v-on="on"
            >
            <v-badge
              v-if="collectorHasError(item)"
              color="error"
              dot
              overlap
            >
              <v-icon color="#2E2B3F">more_horiz</v-icon>
            </v-badge>
            <v-icon v-else color="#2E2B3F">more_horiz</v-icon>
            </v-btn>
          </template>
          <v-list class="api-key-edit">
            <v-list-item
              :key="1"
               @click="$emit('openEditDialog', item)"
            >
              <i class="pe-7s-edit fs-18 delete-button mr-2" style="color: #A9A9A9"></i>
              <v-list-item-title>Edit</v-list-item-title>
              <v-list-item-icon v-if="collectorHasError(item)">
                <v-icon dense color="error">mdi-alert-circle</v-icon>
              </v-list-item-icon>
            </v-list-item>
            <v-list-item
              :key="2"
              @click="$emit('openEditInterval', item)"
            >
              <i class="pe-7s-trash fs-18 delete-button mr-2" style="color: #A9A9A9"></i>
              <v-list-item-title color="red">Change Polling Interval</v-list-item-title>
            </v-list-item>
            <v-list-item
              :key="41"
              @click="$emit('openScan', item)"
            >
              <i class="pe-7s-trash fs-18 delete-button mr-2" style="color: #A9A9A9"></i>
              <v-list-item-title color="red"> {{ scanText() }} </v-list-item-title>
            </v-list-item>
            <v-list-item
              :key="5"
              @click="$emit('openUpdateItemDialog', item)"
            >
              <i class="pe-7s-trash fs-18 delete-button mr-2" style="color: #A9A9A9"></i>
              <v-list-item-title color="red">Update</v-list-item-title>
            </v-list-item>
            <v-list-item
              :key="9"
              @click="$emit('openConfigureSecurityItemDialog', item)"
              v-if="!item.environment_support.includes('on-prem')"
            >
              <i class="pe-7s-edit fs-18 delete-button mr-2" style="color: #A9A9A9"></i>
              <v-list-item-title>Configure Security</v-list-item-title>
            </v-list-item>
            <v-list-item
              :key="6"
              @click="$emit('openAllowedTimeDialog', item)"
            >
              <i class="pe-7s-trash fs-18 delete-button mr-2" style="color: #A9A9A9"></i>
              <v-list-item-title color="red"> Allowed Time </v-list-item-title>
            </v-list-item>
            <v-list-item
              :key="7"
              @click="$emit('openLogs', item)"
            >
              <i class="pe-7s-trash fs-18 delete-button mr-2" style="color: #A9A9A9"></i>
              <v-list-item-title color="red"> Logs </v-list-item-title>
            </v-list-item>
            <v-list-item
              :key="8"
              @click="$emit('openDeleteItemDialog', item)"
            >
              <i class="pe-7s-trash fs-18 delete-button mr-2" style="color: #A9A9A9"></i>
              <v-list-item-title color="red">Delete</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </td>
  </tr>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CollectorItem',
  props: {
    item: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      rerender: false,
      environmentLogo: {
        aws: require('../../../assets/img/menu/aws.png'),
        azure: require('../../../assets/img/menu/azure.png'),
        google: require('../../../assets/img/menu/google.png'),
        azureLake: require('../../../assets/img/menu/azureLake.png'),
        azureBlob: require('../../../assets/img/menu/azureBlob.png'),
        slack: require('../../../assets/img/menu/slack.png'),
        azureLogo: require('../../../assets/img/menu/azurelogo.png')
      }
    }
  },
  computed: {
    ...mapGetters({
      theme: 'colorPaletteServices/theme'
    }),
    ...mapGetters(['license', 'currentOrganization']),
    cloudServices () {
      return (this.item && this.item.configure_security) ? Object.keys(this.item.configure_security) : []
    },
    majorCloudServices () {
      const res = []
      this.cloudServices.forEach(service => {
        if (service.includes('aws') && !res.includes('aws')) res.push('aws')
        else if (service.includes('google') && !res.includes('google')) res.push('google')
        else if (service.includes('azure') && !res.includes('azureLogo')) res.push('azureLogo')
      })
      return res
    }
  },
  methods: {
    collectorHasError (collector) {
      return (
        collector.status?.toLowerCase() === 'active' && collector?.cluster_status?.reachable === false
      )
    },
    getStatusClass (status) {
      let className = 'grey'
      if (!status) {
        return className
      }
      switch (status.toLocaleLowerCase()) {
        case 'active':
          className = 'ok'
          break
        case 'warning':
          className = 'warning'
          break
        case 'offline':
          className = 'error'
          break
      }
      return className
    },
    scanText () {
      try {
        return this.license.description === 'free' ? 'Sample Scan' : 'Scan'
      } catch (error) {
        this.$store.dispatch('fetchOrganizationLicense', this.currentOrganization.entity_id)
          .then(() => {
            this.rerender = !this.rerender
          })
      }
      return 'Sample Scan'
    },
    cloudLabel (service) {
      if (service === 'aws') return 'Amazon Web Services'
      else if (service === 'google') return 'Google Cloud Platform'
      else if (service === 'azure') return 'Azure/Office365'
      else if (service === 'azureLake') return 'Azure Data Lake Storage'
      else if (service === 'azureBlob') return 'Azure Blob'
      else if (service === 'slack') return 'Slack'
      else return ''
    },
    calLeft (index, total) {
      return (index == 0 & total == 1) ? '28px' : ((index + 1) * 15) + 'px'
    }
  },
  mounted () {
    const query = this.$route.query
    if (this.item && (query.collector_id === this.item.entity_id) && query.google && query.type == 'configure') {
      this.$emit('openConfigureSecurityItemDialog', this.item, { code: query.code, google: query.google, error: query.error })
    }
  }
}
</script>

<style scoped>
  .grey {
    background-color: #BDC9D0 !important;
    border-color: #BDC9D0 !important;
  }
  .blur {
    filter: blur(0.5px);
    -webkit-filter: blur(0.5px);
  }
  .cloud-logo {
    position: absolute;
    top: 8px;
    cursor: pointer
  }
</style>
<style lang="scss">
  .v-tooltip__content {
    opacity: 1 !important;
    .tooltip-contailer {
      text-align: center;
      .logos-container {
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        .logo {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 10px;
          font-size: 9px;
        }
      }
    }
  }
</style>
